import SigliveServiceV2 from 'Service/sigliveServiceV2';

const getMe = async () => {
  const { data } = await SigliveServiceV2({ method: 'GET', url: '/me' });

  return data;
};

export default getMe;
